import IVerifyPasswordRequestDTO from '../entities/IVerifyPasswordRequestDTO'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IVerifyPassword {
  execute(data: IVerifyPasswordRequestDTO): Promise<void>
}

export default class VerifyPassword implements IVerifyPassword {
  constructor(private readonly pagamentoRepository: IPagamentoRepository) {}

  public async execute(data: IVerifyPasswordRequestDTO): Promise<void> {
    return this.pagamentoRepository.verifyPassword(data)
  }
}
